var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse',{model:{value:(_vm.openedTabs),callback:function ($$v) {_vm.openedTabs=$$v},expression:"openedTabs"}},[_c('el-collapse-item',{attrs:{"title":_vm.$t('myLoads.myLoadsDetail.loadDetails'),"name":"lineItems"}},[(_vm.selectedLineItems)?_c('InfoLineItems',{attrs:{"selectedLineItems":_vm.selectedLineItems}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }